import React, { useState } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft'

import { toast } from 'react-toastify'
import { Helmet } from 'react-helmet'

import * as yup from 'yup'

import { Heading } from '@peracto/peracto-ui'
import { CREATE, useClient, getSchemaFromResource } from '@peracto/client'

import { MODE_ADD } from '../ArticleCategoryForm'

const ArticleCategoryAdd = ({ ArticleCategoryForm }) => {
    const { client, getResource } = useClient()
    const [redirect, setRedirect] = useState()

    const schema = getSchemaFromResource(getResource('article-categories'))

    const onSubmit = async (data, actions) => {
        try {
            const response = await client(CREATE, 'article-categories', {
                data: {
                    ...data,
                    parent: data?.parent?.value || null,
                },
            })

            if (response.data.violations && response.data.violations.length > 0) {
                // Display errors for invalid fields
                actions.setSubmitting(false)
                response.data.violations.map(error => {
                    actions.setFieldError(error.propertyPath, error.message)
                })
            } else {
                setRedirect(response.data.id)
                toast.success('Article Category successfully added!')
                actions.setSubmitting(false)
            }
        } catch (e) {
            console.error(e)
            toast.error(
                e?.error?.body?.hasOwnProperty('hydra:description')
                    ? e.error.body['hydra:description']
                    : 'Whoops, there was a problem...'
            )
            if (e?.error?.body?.violations?.length > 0) {
                // Display errors for invalid fields
                actions.setSubmitting(false)
                e.error.body.violations.map(error => {
                    actions.setFieldError(error.propertyPath, error.message)
                })
            }
            actions.setSubmitting(false)
        }
    }

    if (redirect) {
        return <Redirect to={redirect} />
    }

    return (
        <>
            <Helmet>
                <title>Article Categories | Add | Peracto</title>
            </Helmet>
            <div className="form-container">
                <Heading name="Add Article Category">
                    <div className="!grow !flex !items-center !justify-end">
                        <Link
                            className="btn btn-outline-primary"
                            to="/article-categories"
                            data-testid="back-to-article-categories"
                        >
                            <FontAwesomeIcon icon={faArrowCircleLeft} className="!mr-2" />
                            Back to Article Categories
                        </Link>
                    </div>
                </Heading>
                <ArticleCategoryForm onSubmit={onSubmit} mode={MODE_ADD} schema={schema} />
            </div>
        </>
    )
}

export default ArticleCategoryAdd
